<template>
    <div class="crowdfunding-detail">
        <div class="title-cover">
            <div class="big-title">
                D!Zhu <div class="right"></div>
            </div>
            <div class="small-title">
                优选品质众筹
            </div>

            <div class="sub-title">
                规则简介:倒计时结束前当前商品预付人数超过{{cr_info.cr_amount}}人即可直接成团(如未完成所有货款将在2-3个工作日内原路退还)
            </div>
        </div>

        <div class="intro">
            <div class="percent" :style='`width:${cr_percent}%`'></div>
            剩余&nbsp;{{cr_info.amount_can_buy}}{{cr_info.unit?cr_info.unit:'个'}}&nbsp;&nbsp;截止&nbsp;
           
            <van-count-down :time="detail.endtime/1000" format="DD 天 HH 时 mm 分 ss 秒" />&nbsp;
            <van-icon name="info" />
        </div>

        <div class="detail">
            <van-image width="100%" :src="img" v-for='img in detail.detail_imgs' />
        </div>
        <van-goods-action>
            <van-goods-action-icon icon="chat-o" text="客服" @click="contact" />



            <van-goods-action-button type="danger" text="立即预购" @click="open_buy" />
        </van-goods-action>
        <van-sku v-if='!loading_detail' v-model="show_product" :sku="sku_info.sku" :goods="sku_info.goods" :goods-id="sku_info.goodsId" :hide-stock="false" :quota="sku_info.quota" :quota-used="sku_info.quotaUsed" @buy-clicked="buy" :show-add-cart-btn='false'>

        </van-sku>
        <van-popup v-model="show_contact">请联系客服shirenyuhai</van-popup>
        
        <van-popup v-model="show_edit" position="bottom" round>内容</van-popup>
        <address-list ref='address_list' @success='callpay'></address-list>
    </div>
</template>
<script>
    import mixin from "../mixin.vue";
    import AddressList from '@/components/address-list.vue';
    export default {
        components:{
            AddressList
        },
        data() {
            return {
                show_edit: false,
                show_contact: false,
                show_product: false,
                chosenAddressId: '1',
                loading_detail: true,
                
                sku_info: {
                    hide_stock: false
                },
                cr_info: {}, //众筹信息
                detail: {},
                order:{
                    sku_id:15
                }
            }
        },
        computed: {
            cr_id() {

                return this.$route.query.cr_id
            },
            cr_percent() {
                let cr = this.cr_info
                return cr.already_buy / cr.cr_amount * 100
            }
        },
        mixins: [mixin],
        mounted() {
            let self = this
            self.get_crowdfunding()
        },
        methods: {
            get_crowdfunding() {
                let self = this
                self.$http.post('/v1/get_crowdfunding', {
                    product_id: self.cr_id
                }).then(function(re) {
                    self.detail = re.body.product_info
                    self.cr_info = re.body.cr_info
                    self.loading_detail = false
                    self.sku_info = self.trans_product(re.body)
                })
            },
            open_buy() {
                let self = this
                self.show_product = true
            },
            contact() {
                let self = this
                self.show_contact = true
            },
            buy(a,b) {
                let self = this
                self.order.sku_id = a.goodsId
                console.log(a,b)
                self.$refs.address_list.open()
            },
            callpay: function(address_id) {
                let self = this
                let product = self.detail
                let product_id = product.id
                if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', jsApiCall);
                        document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
                    }
                    return
                }
                console.log(product_id,self.order.sku_id,address_id)
                self.$http.post("/v1/get_jsapi", {
                    product_id:product_id,
                    sku_id:self.order.sku_id,
                    address_id:address_id,
                    product_type:"crowdfunding"
                }).then(function(data) {
                    console.log('签名信息',data)
                    let sign = data.body.info
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', {
                            appId: sign["appId"],
                            timeStamp: sign["timeStamp"],
                            nonceStr: sign["nonceStr"],
                            package: sign["package"],
                            signType: "MD5",
                            paySign: sign["paySign"]
                        },
                        function(res) {
                            if (res.err_msg == "get_brand_wcpay_request:ok") {
                                
                            self.show_product = false
                                self.show_address = false
                                self.$toast('购买成功')
                                self.get_crowdfunding()
                            } else {
                                alert("支付失败啦,如果持续存在问题,请联系小助手 shirenyuhai ")
                            }
                        }
                    );

                })


            }
        }
    }

</script>
<style lang='scss'>
    .crowdfunding-detail {
        margin-bottom: 70px;

        .btn {
            cursor: pointer;
        }

        .title-cover {
            position: relative;

        }

        .big-title {
            margin: 10px 15px;
            margin-bottom: 0px;
            font-size: 105px;
            font-weight: bolder;
            color: black;

        }

        .small-title {
            margin: 0px 15px;
            font-size: 30px;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .sub-title {

            color: #909091;
            font-size: 14px;
            margin: 0px 15px;
            margin-bottom: 20px;

        }

        .back-video {
            width: 100%;
        }

        .intro {
            display: flex;
            align-items: center;
            padding: 15px;
            background-color: rgba(0, 0, 0, .15);
            color: white;
            height: 60px;
            box-sizing: border-box;
            font-size: 12px;
            position: relative;

            .van-count-down {
                color: white;
            }

            .percent {
                position: absolute;
                top: 0;
                left: 0;
                height: 60px;
                z-index: -1;
                background-color: #5A636D;
                width: 20%;

            }
        }

        .ldm-popup {
            .popup-title {
                height: 50px;
                text-align: center;
                line-height: 50px;
            }

            .popup-select-area-body {
                padding: 15px;
                background-color: #F6F8FA;

                .area-card {
                    padding: 15px;
                    background-color: white;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;

                    .left {
                        margin-right: 5px;
                    }

                    .right,
                    .selector {
                        font-size: 20px;
                        padding: 10px;
                    }

                    .right {
                        margin-left: auto;
                    }

                    .selector {
                        color: #323233;

                        .van-icon-checked {
                            color: #ee0a24;
                        }

                    }

                    .title {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        margin-bottom: 5px;

                        .van-tag {
                            margin-left: 5px;
                        }
                    }

                    .detail {
                        font-size: 12px;
                        color: #323233;
                    }
                }
            }

            .btn-group {
                display: flex;
                align-items: center;
                padding: 20px 15px;
                background-color: #F6F8FA;
                padding-top: unset;

                .btn {
                    border-radius: 4px;
                    flex: 1;
                    color: white;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;

                    &.add {
                        background-color: #ee0a24;
                        margin-right: 10px;
                    }

                    &.pay {
                        background-color: #07c160;
                    }

                    &.disable {
                        background-color: #CDCECF;
                        color: white;
                    }


                }
            }
        }

    }

</style>
